import React from 'react';
import { ReactComponent as DimensionsIcon } from '../../svg/dimensions-icon.svg';
import { BagDetails } from './CommonTypes';
import { FormattedMessage } from 'react-intl';

export function DimensionsText({
  bagDetails,
  className,
}: {
  bagDetails: BagDetails;
  className: string;
}) {
  return (
    <p className={className} style={{ marginTop: '-10px' }}>
      <DimensionsIcon className="gr-pr-1" />{' '}
      <FormattedMessage id="l" defaultMessage="l" /> +{' '}
      <FormattedMessage id="w" defaultMessage="w" /> +{' '}
      <FormattedMessage id="h" defaultMessage="h" />
      {' < ' + bagDetails.total_dimensions + ' ' + bagDetails.dimension_unit}
    </p>
  );
}
